<template>  
  <section id="notes">
    <header>
      <ul class="notes-filter alternative-list">
        <li 
          v-for="(audience, i) in audiences"
          v-bind:key="i"
          v-bind:class="{'selected': audiences[i].selected == true}" 
          @click="selectAudience(i)">
          {{ audience.name }}
          </li>
      </ul>
    </header>
    <ul class="notes">
      <li v-if="!notes.current">Det finns inga aktuella noteringar att visa här</li>
      <li 
      v-for="(note, i) in notes.current"
      v-bind:key="i"
      >
        <div class="checkbox-container">
          <button class="checkbox" v-if="note.is_todo == 1" v-on:click="toggleDone(note)" v-bind:data-checked="note.done">&nbsp;</button>
        </div>
        <div class="note">
          <h1>{{ roomslookup[note.room_id] }}</h1>
          <span class="created-at">{{ note.created_at }}</span>
          <p>{{ note.title }}</p>
          <span class="edit-note" @click="$parent.editNote(note)"><i class="fas fa-pen"></i></span>
        </div>
      </li>
    </ul>
    <header>
      <h2>Nyligen slutförda</h2>
    </header>
    <ul class="notes">
      <li 
      v-for="(note, i) in notes.recent"
      v-bind:key="i"
      >
        <div class="checkbox-container">
          <button class="checkbox" v-if="note.is_todo == 1" v-on:click="toggleDone(note)" v-bind:data-checked="note.done">&nbsp;</button>
        </div>
        <div class="note">
          <h1>{{ roomslookup[note.room_id] }}</h1>
          <span class="created-at">
            {{ note.created_at }}
          </span>
          <p>{{ note.title }}</p>
        </div>
      </li>
    </ul>
  </section>
</template>
<script>
import axios from 'axios'

  export default {  
    name: 'Notes',  
    props: {
      notes: Object,
      roomslookup: Object,
      audiences: Array
    },
    data () { 
      return {}
    },
    methods: {
      selectAudience(id){
        this.audiences[id].selected = !this.audiences[id].selected;
        this.$forceUpdate();
        this.fetchNotes();
      },
      fetchNotes(){
        let self = this;
        self.notes.current = [];
        self.notes.recent = [];

        axios
        .get(self.$parent.api_url + "/notes", {
          params: {
            audiences: self.audiences
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + self.$parent.client.token
          }
        })
        .then(response => {
          self.notes.current = response.data.active;
          self.notes.recent = response.data.recent;
          self.reloading = false;
        })
        .catch(function(error) {
          this.log(error);
          this.log("Something went wrong while loading notes");
        });
      },
      toggleDone(note){
        this.$parent.toggleDone(note);
      }
    },
    mounted: function(){
      this.fetchNotes()
    },
    watch: {
    },
    computed: {
      selectedAudiences(){
        var selected = [];
        Object.keys(this.audiences).forEach(key => {
          if( this.audiences[key].selected ){
            selected.push(this.audiences[key].id);
          }
        });
        return selected;
      },
      filteredNotes(){
        let self = this;
        return this.notes.current;
        var included_notes = [];
        
        if( this.note_audience_filter === 1 ){
          return this.notes.current;
        }
        this.notes.current.forEach( function(i){
          if( note.audience_ids.indexOf(self.note_audience_filter) > -1 ){
            included_notes.push(i);
          }
        });
        return included_notes;
      },
    }
  }
</script>
<style scoped>

</style>
